import { NavigateNext } from "@material-ui/icons";
import axios from "axios";
import jsPDF from "jspdf";
import moment from "moment";
import pdfExport from "../../../../components/invoice-generator/pdfExport";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import { callAddFont } from "../../../../Reviews/amiri-font";
import { GetA4Setings } from "../../../../services/settings-services";
//import { convertBlobToBase64 } from "../../../Settings/invoice-settings/invoice-templates/test-template";
import printJS from "print-js";

const drawCustomerInvoice = (doc, info, locInv, tot, foundInfo, count) => {
  let y = 0;
  const imgData = `data:image/jpeg;base64,${foundInfo.Logo}`;
  doc.addImage(imgData, "JPEG", 22, y, 55, 35);
  y += 40;
  doc.text(foundInfo.nameA, 50, y, null, null, "center");
  y += 5;
  doc.text("Phone No:" + foundInfo.Mobile, 50, y, null, null, "center");
  y += 5;
  doc.text("VAT# " + foundInfo.tax_no, 50, y, null, null, "center");
  y += 5;
  doc.text(
    tot.tax_no_cust === ""
      ? "فاتورة ضريبية مبسطة"
      : "فاتورة ضريبية" + foundInfo.tax_no,
    50,
    y,
    null,
    null,
    "center"
  );
  y += 5;
  // const height = info.length * 11 + 50;
  // doc.addPage([100, height], "p");
  // console.log(":the data is", info);
  // y = 0;
  doc.text(
    locInv.invN + " " + tot.inv_type_name + " ",
    50,
    y,
    null,
    null,
    "center"
  );
  y += 10;
  doc.setFontSize(16);
  doc.text(tot.id.toString(), 50, y, null, null, "center");
  y += 7;
  doc.setFontSize(9);
  doc.text(
    moment(tot.date).format("h:mm A YYYY/MM/DD").toString(),
    95,
    y,
    null,
    null,
    "right"
  );

  y += 3;
  doc.rect(5, y, 90, count * 10 + 10);

  doc.text("اسم الصنف", 85, y + 5, null, null, "right");

  doc.text("الكمية ", 45, y + 5, null, null, "center");
  doc.text("السعر ", 32, y + 5, null, null, "center");
  doc.text("الإجمالي ", 15, y + 5, null, null, "center");
  doc.line(50, y, 50, y + count * 10 + 10);
  doc.line(40, y, 40, y + count * 10 + 10);
  doc.line(25, y, 25, y + count * 10 + 10);
  //   y += 7;
  y += 5;
  info?.map((item, i) => {
    doc.line(5, y + 5, 95, y + 5);
    y += 10;

    doc.text(item.symbol.toString(), 94, y, null, null, "right");
    doc.text(item.val1.toString(), 45, y, null, null, "center");
    doc.text(
      item.new_exchange_price?.toString(),
      30,
      y,
      null,
      null,
      "center"
    );
    // y += 4;
    doc.text(item.tot_net_curr.toString(), 15, y, null, null, "center");
  });
  //   doc.line(5, y, 95, y);
  doc.setFontSize(12);
  var subTotal = (tot.tot_net - tot.amountOfVat + tot.discount).toFixed(2);
  y += 10;
  doc.text("الاجمالي قبل الضريبة", 90, y, null, null, "right");
  doc.text(
    (tot.tot_net - tot.amountOfVat + tot.discount)?.toFixed(2).toString(),
    10,
    y
  );
  y += 8;
  doc.text("مجموع الخصومات", 90, y, null, null, "right");
  doc.text(tot.discount?.toFixed(2).toString(), 10, y);
  y += 8;
  doc.text("الاجمالي الخاضع للضريبة", 90, y, null, null, "right");
  doc.text((tot.tot_net - tot.amountOfVat)?.toFixed(2).toString(), 10, y);

  var amVat = Number(tot.amountOfVat).toFixed(2);
  y += 8;
  doc.text("VAT  ضريبة القيمة المضافة", 90, y, null, null, "right");
  doc.text(amVat.toString(), 10, y);
  y += 5;
  doc.line(5, y, 95, y);
  y += 6;
  doc.text(tot.tot_net.toString(), 10, y);
  doc.text("Orand Total الإجمالي", 90, y, null, null, "right");

  y += 10;
  doc.setFontSize(11);
  doc.text(foundInfo.Address.toString(), 50, y, null, null, "center");

  return y;
}

const drawKitchenInvoice = (doc_kitchen, info, tot, count) => {
  // Kitchen data
  doc_kitchen.setFontSize(12);
  doc_kitchen.text("رقم الفاتورة: ", 95, 10, null, null, "right");
  doc_kitchen.text(tot.id.toString(), 50, 10, null, null, "center");
  doc_kitchen.text(
    moment(tot.date).format("h:mm A YYYY/MM/DD").toString(),
    95,
    17,
    null,
    null,
    "right"
  );
  doc_kitchen.rect(5, 22, 90, count * 10 + 10);

  doc_kitchen.text("اسم الصنف", 85, 27, null, null, "right");
  doc_kitchen.text("الكمية ", 15, 27, null, null, "center");
  doc_kitchen.line(20, 22, 20, 22 + count * 10 + 10);

  var y1 = 27;
  //   y += 7;
  info?.map((item, i) => {
    doc_kitchen.line(5, y1 + 5, 95, y1 + 5);
    y1 += 10;

    doc_kitchen.text(item.symbol.toString(), 94, y1, null, null, "right");

    // y += 4;
    doc_kitchen.text(item.val1.toString(), 15, y1, null, null, "center");
  });
}

export const handleDirectPrintTemp3 = async (locInv, count, next) => {
  let printers = [];
  let printerGroups = {};
  let tot = {};
  jsPDF.API.events.push(["addFonts", callAddFont]);
  jsPDF.API.events.push(['addFonts', () => { }])
  const lngth = count * 11 + 190;
  const lnth_kitchen = count * 11 + 40;
  var doc = new jsPDF("p", "mm", [100, lngth]);
  let yAfter = 0;

  doc.setFont("Amiri-Regular", "normal");
  doc.setFontSize(11);
  var y = 0;
  const tb = {
    Rpt_Inv: true,
    GetFoundation: true,
    SettInvsApp: true,

    parms: {
      lprocid: locInv.proc_id,
      ibranchid: locInv.branch,
      sProcTypeInvProc: locInv.ProcTypeInvProc,
      iFoundid: 1,
      withPrinters: true,
      branch: sto.branchi,
    },
    autos: {},
  };

  // console.log("athe isda", );
  await axios
    .post(`${uri}Res`, tb)
    .then(async (res) => {
      console.log("res.data.RptInv");
      console.log(res.data);
      const info = res.data.RptInv;
      tot = res.data.infoBill;
      const foundInfo = res.data.Found;
      printers = res.data?.printers?.map((p) => p[0]);
      const itemsPrinters = res.data?.items_printers || [];
      console.log("itemsPrinters", itemsPrinters);

      for (const item of itemsPrinters) {

        if (!printerGroups[item.printer_name]) {
          printerGroups[item.printer_name] = [];
        }
        const matchItems = info.filter((i) => i.currency_from == item.currency_from);
        printerGroups[item.printer_name].push(...matchItems);
      }
      // console.log(printers);
      yAfter = drawCustomerInvoice(doc, info, locInv, tot, foundInfo, count);


      // Kitchen data

    })
    .catch((error) => { });

  await axios
    .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
    .then(async (res) => {
      yAfter += 5;
      const imgF = `data:image/jpeg;base64,${res.data.qr_image}`;
      doc.addImage(imgF, "JPEG", 30, yAfter, 40, 40);
      next();
    })
    .catch((error) => {
      //   setGenerating(false);
    });
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
  const pdf = doc.output("blob");
  const formData = new FormData();
  formData.append("PdfFile", pdf);
  formData.append(
    "PrinterPath",
    "\\\\" + premiApp.deviceName + "\\" + premiApp.printerName
  );
  // await doc.save("restaurant invoice");
  // const base64String = await convertBlobToBase64(pdf);
  // printJS({ printable: base64String, type: "pdf", base64: true });
  // setBase64String(base64String);

  await axios
    .post("http://localhost:7000/print/from-pdf", formData, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log("pdf printer successfully");
    })
    .catch((err) => {
      console.log("error", err);
    });


  await Promise.all(
    Object.entries(printerGroups).map(async ([printer_name, items]) => {
      const kitchenHeight = items.length * 11 + 40;
      const doc_kitchen = new jsPDF({
        orientation: "p", unit: "mm", format: [100, kitchenHeight]
      });
      doc_kitchen.setFont("Amiri-Regular", "normal").setFontSize(11);

      drawKitchenInvoice(doc_kitchen, items, tot, items.length);
      const pdf_kitchen = doc_kitchen.output("blob");
      const formData_kitchen = new FormData();
      formData_kitchen.append("PdfFile", pdf_kitchen);
      formData_kitchen.append(
        "PrinterPath",
        "\\\\" + premiApp.deviceName + "\\" + printer_name
      );

      await axios
        .post("http://localhost:7000/print/from-pdf", formData_kitchen, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("pdf printer kithchen successfully", printer_name);
        })
        .catch((err) => {
          console.log("error", err);
        });
      // await doc_kitchen.save("kitchen1 inv");


    })
  );
};
export const handleDirectPrintTemp22 = async (locInv, count, next) => {
  let newWindow = false;
  const invoice = {
    uuid: 44,
    title: "Invoice No:",
    invoiceNo: 66,
    invoiceDate: new Date().toLocaleDateString("en-CA"),
    dueDate: "",
    invoiceFrom: "",
    invoiceTo: "",
    discounts: 0,
    shipping: 0,
    currency: "USD",
    taxation: "GST",
  };
  let printerGroups = {};
  await printInvoice(locInv, async (data, inv) => {
    const a4Settings = GetA4Setings();
    let newObj = {
      ...invoice,
      ...a4Settings,
      found: data?.Found,
      imgSrc: `data:image/jpeg;base64,${data?.Found?.Logo}`,
      footNote: data?.Found?.BillNotes,
      items: data?.RptInv,
      tot: data?.infoBill,
      terms: inv?.notes,
      // locInv: { invN: "فاتورة مبيعات" },
      locInv: {
        invN: "فاتورة مبيعات",
      },
      premiApp: { hidePayType: false },
      inv: inv,
    };
    const itemsPrinters = data?.items_printers || [];
    console.log("itemsPrinters", itemsPrinters);
    console.log("itemsPrinters", data.RptInv);
    const info = data.RptInv;
    for (const item of itemsPrinters) {
      if (!printerGroups[item.printer_name]) {
        printerGroups[item.printer_name] = [];
      }
      const matchItems = info.filter(
        (i) => i.currency_from == item.currency_from
      );
      console.log("the new matchItems  is", info);

      printerGroups[item.printer_name].push(...matchItems);
    }
    // server name : WIN-R79J4H5EHN0
    // my device: DESKTOP-4PUU0JT
    // console.log("the new data is", newObj);
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    const parts = premiApp?.deviceName?.split("|");
    let deviceName = parts[0]?.trim();
    let ipAddress = parts[1]?.trim();

    if (!ipAddress) {
      ipAddress = "localhost"
    }
    const pdfDocGenerator = pdfExport.getRestInvoice(newObj);
    // pdfDocGenerator.download("resturant No#");
    pdfDocGenerator.getBlob(async (blob) => {
      console.log("deviceName", deviceName)
      console.log("ipAddress", ipAddress)
      // pdfDocGenerator.download("res#");
      const formData = new FormData();
      formData.append("PdfFile", blob);
      formData.append(
        "PrinterPath",
        "\\\\" + deviceName + "\\" + premiApp.printerName
      );

      await axios
        .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
        })
        .catch((err) => {
          console.error("فشل إرسال فاتورة العميل للطابعة", err);
        });
    });
    console.log("the printernameis", printerGroups);
    await Promise.all(
      Object.entries(printerGroups).map(async ([printer_name, items]) => {
        const obj = {
          ...newObj,
          items: items,
        };
        const pdfDocGenerator = pdfExport.getKitchenInvoice(obj);
        // pdfDocGenerator.download("kitchen No#");
        console.log("the printernameis", items);
        pdfDocGenerator.getBlob(async (blob) => {
          const formData = new FormData();
          formData.append("PdfFile", blob);
          formData.append(
            "PrinterPath",
            "\\\\" + deviceName + "\\" + printer_name
          );

          await axios
            .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
              headers: {
                "Content-type": "multipart/form-data",
              },
            })
            .then((res) => {
              console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
            })
            .catch((err) => {
              console.error("فشل إرسال فاتورة العميل للطابعة", err);
            });
        });

        // await doc_kitchen.save("kitchen1 inv");
      })
    );
    // pdfExport.pdfDocGenerator(newObj, newWindow);
    // if (actionName == "print") pdfExport.printInvoice(newObj, newWindow);
    // else if (actionName == "download") pdfExport.downloadInvoice(newObj);
    // else pdfExport.shareInvoice(newObj);
  })
    .then()
    .catch((res) => {
      next();
    });
  next();
};

export const handleDirectPrintCasair = async (locInv, next, premiApp,foundData, setFoundData) => {
  let newWindow = false;
  const invoice = {
    uuid: 44,
    title: "Invoice No:",
    invoiceNo: 66,
    invoiceDate: new Date().toLocaleDateString("en-CA"),
    dueDate: "",
    invoiceFrom: "",
    invoiceTo: "",
    discounts: 0,
    shipping: 0,
    currency: "USD",
    taxation: "GST",
  };
  // let printerGroups = {};
  await printInvoiceData(locInv, foundData, setFoundData, async (data) => {
    // const a4Settings = GetA4Setings();
    let found=foundData?.found?.id > 0?foundData?.found : data?.Found;
    let newObj = {
      ...invoice,
      // ...a4Settings,
      found: found,
      imgSrc: `data:image/jpeg;base64,${found?.Logo}`,
      footNote: found?.BillNotes,
      items: data?.RptInv,
      tot: data?.infoBill,
      terms:  locInv?.invs?.notes,
      locInv: {
        invN: locInv.ProcTypeInvProc === "02" ? "فاتورة مبيعات" : locInv.ProcTypeInvProc === "01" ? "فاتورة مشتريات"
          : locInv.ProcTypeInvProc === "11" ? "فاتورة مرتجع مشتريات" : locInv.ProcTypeInvProc === "12" ? "فاتورة مرتجع مبيعات"
            : locInv.ProcTypeInvProc === "03" ? "فاتورة عرض سعر " : 
            locInv.ProcTypeInvProc === "04" ? "فاتورة طلب شراء " : "مخزن اول مدة"
      },
      premiApp: { hidePayType: false },
      inv: locInv?.invs,
      invSet: foundData?.found?.id > 0? foundData.invSet: data.SettInvsApp,
      Step_inv2:locInv.Step_inv2,
    };
    // const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    const parts = premiApp?.deviceName?.split("|");
    let deviceName = parts[0]?.trim();
    let ipAddress = parts[1]?.trim();

    if (!ipAddress) {
      ipAddress = "localhost"
    }
    const pdfDocGenerator = pdfExport.getCashairInvoice(newObj);
    pdfDocGenerator.getBlob(async (blob) => {
      const formData = new FormData();
      formData.append("PdfFile", blob);
      formData.append(
        "PrinterPath",
        "\\\\" + deviceName + "\\" + premiApp.printerName
      );
      // pdfDocGenerator.download(blob);
      await axios
        .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
        })
        .catch((err) => {
          console.error("فشل إرسال فاتورة العميل للطابعة", err);
        });
    });
  })
    .then()
    .catch((res) => {
      next();
    });
  next();
};
export const handleDirectPrintRest = async (locInv, next, copy, premiApp, foundData, setFoundData) => {
  let newWindow = false;

  const invoice = {
    uuid: 44,
    title: "Invoice No:",
    invoiceNo: 66,
    invoiceDate: new Date().toLocaleDateString("en-CA"),
    dueDate: "",
    invoiceFrom: "",
    invoiceTo: "",
    discounts: 0,
    shipping: 0,
    currency: "USD",
    taxation: "GST",
  };
  let printerGroups = {};
  await printInvoiceData(locInv, foundData, setFoundData, async (data) => {
    const a4Settings = GetA4Setings();
    let found=foundData?.found?.id > 0?foundData?.found : data?.Found;
    let newObj = {
      ...invoice,
      ...a4Settings,
      found: found,
      imgSrc: `data:image/jpeg;base64,${found?.Logo}`,
      footNote: found?.BillNotes,
      items: data?.RptInv,
      tot: {
        ...data?.infoBill, tawlaName: data?.infoBill?.tawlaName != "" && data?.infoBill?.tawlaName != null
          ? data?.infoBill?.tawlaName : ""
      },
      terms: locInv?.invs?.notes,
      copy: Number(copy),
      locInv: {
        invN: "فاتورة مبيعات",
      },
      premiApp: { hidePayType: false },
      inv: locInv.invs,
      Step_inv2:locInv?.Step_inv2,
    };
    const itemsPrinters = data?.items_printers || [];
    const info = data.RptInv;
    // ==========================================
    // تجهيز الأصناف في Map مرة واحدة
    // يدعم وجود أكثر من صنف بنفس currency_from
    // ==========================================

    const infoMap = new Map();
    for (const infoItem of info) {
      const key = String(infoItem.currency_from);
      if (!infoMap.has(key)) {
        infoMap.set(key, []);
      }
      infoMap.get(key).push(infoItem);
    }
    const printerGroups = {};

    for (const printerItem of itemsPrinters) {
      const printerName = printerItem.printer_name;
      const key = String(printerItem.currency_from);
      // إنشاء مجموعة الطابعة
      if (!printerGroups[printerName]) {
        printerGroups[printerName] = [];
      }
      // جلب الأصناف مباشرة من Map
      const matchItems = infoMap.get(key);
      if (matchItems) {
        printerGroups[printerName].push(...matchItems);
      }
    }
    // const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    const parts = premiApp?.deviceName?.split("|");
    let deviceName = parts[0]?.trim();
    let ipAddress = parts[1]?.trim();
    if (!ipAddress) {
      ipAddress = "localhost"
    }

    const pdfDocGenerator = pdfExport.getRestInvoice(newObj);
    pdfDocGenerator.getBlob(async (blob) => {
      const formData = new FormData();
      formData.append("PdfFile", blob);
      formData.append(
        "PrinterPath",
        "\\\\" + deviceName + "\\" + premiApp.printerName
      );
      if ([6, 4, 1, 0].includes(Number(copy))) {
        // pdfDocGenerator.download(blob);
        await axios
          .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
            headers: {
              "Content-type": "multipart/form-data",
            },
          })
          .then((res) => {
            console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
          })
          .catch((err) => {
            console.error("فشل إرسال فاتورة العميل للطابعة", err);
          });
      } else {
        for (let i = 0; i < parseFloat(copy); i++) {
          await axios
            .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
              headers: {
                "Content-type": "multipart/form-data",
              },
            })
            .then((res) => {
              console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
            })
            .catch((err) => {
              console.error("فشل إرسال فاتورة العميل للطابعة", err);
            });
        }
      }

    });
    // console.log("the printernameis", printerGroups);
    await Promise.all(
      Object.entries(printerGroups).map(async ([printer_name, items]) => {
        const obj = {
          ...newObj,
          items: items,
        };
        const pdfDocGenerator = parseFloat(copy) > 5 ? pdfExport.getRestInvoice(newObj) : pdfExport.getKitchenInvoice(obj);
        // const pdfDocGenerator =  pdfExport.getKitchenInvoice(obj);
        pdfDocGenerator.getBlob(async (blob) => {
          const formData = new FormData();
          formData.append("PdfFile", blob);
          formData.append(
            "PrinterPath",
            "\\\\" + deviceName + "\\" + printer_name
          );
          // pdfDocGenerator.download(blob);
          await axios
            .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
              headers: {
                "Content-type": "multipart/form-data",
              },
            })
            .then((res) => {
              console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
            })
            .catch((err) => {
              console.error("فشل إرسال فاتورة العميل للطابعة", err);
            });
        });

      })
    );
  })
    .then()
    .catch((res) => {
      next();
    });
  next();
};
export const handleDirectPrintOnther = async (locInv, count) => {
  let newWindow = false;
  const invoice = {
    uuid: 44,
    title: "Invoice No:",
    invoiceNo: 66,
    invoiceDate: new Date().toLocaleDateString("en-CA"),
    dueDate: "",
    invoiceFrom: "",
    invoiceTo: "",
    discounts: 0,
    shipping: 0,
    currency: "USD",
    taxation: "GST",
  };
  let printerGroups = {};
  await printInvoice(locInv, async (data, inv) => {
    const a4Settings = GetA4Setings();
    let newObj = {
      ...invoice,
      ...a4Settings,
      found: data?.Found,
      imgSrc: `data:image/jpeg;base64,${data?.Found?.Logo}`,
      footNote: data?.Found?.BillNotes,
      items: data?.RptInv,
      tot: data?.infoBill,
      terms: inv?.notes,
      locInv: {
        invN: "فاتورة مبيعات",
      },
      premiApp: { hidePayType: false },
      inv: inv,
    };
    const itemsPrinters = data?.items_printers || [];
    console.log("itemsPrinters", itemsPrinters);
    console.log("itemsPrinters", data.RptInv);
    const info = data.RptInv;
    for (const item of itemsPrinters) {
      if (!printerGroups[item.printer_name]) {
        printerGroups[item.printer_name] = [];
      }
      const matchItems = info.filter(
        (i) => i.currency_from == item.currency_from
      );
      console.log("the new matchItems  is", info);

      printerGroups[item.printer_name].push(...matchItems);
    }
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    const parts = premiApp?.deviceName?.split("|");
    let deviceName = parts[0]?.trim();
    let ipAddress = parts[1]?.trim();

    if (!ipAddress) {
      ipAddress = "localhost"
    }
    const pdfDocGenerator = pdfExport.getRestInvoice(newObj);
    // pdfDocGenerator.download("resturant No#");
    pdfDocGenerator.getBlob(async (blob) => {
      console.log("deviceName", deviceName)
      console.log("ipAddress", ipAddress)
      // pdfDocGenerator.download("res#");
      const formData = new FormData();
      formData.append("PdfFile", blob);
      formData.append(
        "PrinterPath",
        "\\\\" + deviceName + "\\" + premiApp.printerName
      );

      await axios
        .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
        })
        .catch((err) => {
          console.error("فشل إرسال فاتورة العميل للطابعة", err);
        });
    });
    console.log("the printernameis", printerGroups);


  })
    .then()
    .catch((res) => {
      // next();
    });
  // next();
};

export const openDrawer = async () => {
  // 
  const pdfDocGenerator = pdfExport.getOpenDrawer();
  // pdfDocGenerator.download("resturant No#");
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
  const parts = premiApp?.deviceName?.split("|");
  let deviceName = parts[0]?.trim();
  let ipAddress = parts[1]?.trim();

  if (!ipAddress) {
    ipAddress = "localhost"
  }
  pdfDocGenerator.getBlob(async (blob) => {
    // console.log("deviceName", deviceName)
    // console.log("ipAddress", ipAddress)
    // pdfDocGenerator.download("drawer");
    const formData = new FormData();
    formData.append("PdfFile", blob);
    formData.append(
      "PrinterPath",
      "\\\\" + deviceName + "\\" + premiApp.printerName
    );
    // pdfDocGenerator.download(blob);
    await axios
      .post(`http://${ipAddress}:7000/print/from-pdf`, formData, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("تم إرسال فاتورة العميل للطابعة بنجاح");
      })
      .catch((err) => {
        console.error("فشل إرسال فاتورة العميل للطابعة", err);
      });
  });
}
const printInvoiceData = async (locInv, foundData, setFoundData, nextStep) => {
  var data;

  const tb = {
    Rpt_Inv: true,
    GetFoundation: foundData?.found?.id > 0 ?  false : true,
    SettInvsApp: foundData?.found?.id > 0 ?  false : true,
    parms: {
      lprocid: locInv.proc_id,
      ibranchid: locInv.branch,
      sProcTypeInvProc: locInv.ProcTypeInvProc,
      iFoundid: 1,
      withPrinters: true,
      branch: sto.branchi,
    },
    autos: {},
  };

  await axios
    .post(uri + "Res", tb)
    .then(async (res) => {
      data = res.data;
      if(!foundData?.found?.id){
        setFoundData({found:res?.data?.Found,invSet:res.data.SettInvsApp});
      }
    })
    .catch((error) => { });

  nextStep(data);
};
const printInvoice = async (locInv, nextStep) => {
  var data, inv;

  const tb = {
    Rpt_Inv: true,
    GetFoundation: true,
    // SettInvsApp: true,
    parms: {
      lprocid: locInv.proc_id,
      ibranchid: locInv.branch,
      sProcTypeInvProc: locInv.ProcTypeInvProc,
      iFoundid: 1,
      withPrinters: true,
      branch: sto.branchi,
    },
    autos: {},
  };

  await axios
    .post(uri + "Res", tb)
    .then((res) => {
      console.log("the data is", res.data);
      data = res.data;
    })
    .catch((error) => {
      // console.log("erooooorroro");
    });

  await axios
    .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
    .then(async (res) => {
      inv = res.data;
    })
    .catch((error) => { });

  nextStep(data, inv);
};

export const PrintInvoiceDirectly = async (locInv, newWindow = true, actionName = "print", next) => {
  const invoice = {
    uuid: 44,
    title: "Invoice No:",
    invoiceNo: 66,
    invoiceDate: new Date().toLocaleDateString("en-CA"),
    dueDate: "",
    invoiceFrom: "",
    invoiceTo: "",
    discounts: 0,
    shipping: 0,
    currency: "USD",
    taxation: "GST",
  };
  await printInvoice(locInv, async (data, inv) => {
    const a4Settings = GetA4Setings();
    let newObj = {
      ...invoice,
      ...a4Settings,
      found: data?.Found,
      imgSrc: `data:image/jpeg;base64,${data?.Found?.Logo}`,
      footNote: data?.Found?.BillNotes,
      items: data?.RptInv,
      tot: data?.infoBill,
      terms: inv?.notes,
      // locInv: { invN: "فاتورة مبيعات" },
      locInv: {
        invN: locInv.ProcTypeInvProc === "02" ? "فاتورة مبيعات" : locInv.ProcTypeInvProc === "01" ? "فاتورة مشتريات"
          : locInv.ProcTypeInvProc === "11" ? "فاتورة مرتجع مشتريات" : locInv.ProcTypeInvProc === "12" ? "فاتورة مرتجع مبيعات"
            : locInv.ProcTypeInvProc === "03" ? "فاتورة عرض سعر " : locInv.ProcTypeInvProc === "04" ? "فاتورة طلب شراء " : "مخزن اول مدة"
      },
      premiApp: { hidePayType: false },
      inv: inv,
    };
    console.log("the new data is", newObj);
    pdfExport.printInvoice(newObj, newWindow);

  })
    .then()
    .catch((res) => {
      next();
    });
};


